module.exports = __webpack_public_path__ + "img/public/SiteIcons/arrow-right-white.svg?0dc08ccf";